// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Traducoes_IdiomaRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** One language of translations-service. `padrao` marks the locale whose text IS the key. */
import { registerContract } from './validate'

export interface Traducoes_IdiomaRow {
codigo?: string
nome?: string
padrao?: boolean
}

registerContract('Traducoes_IdiomaRow', {
  codigo: { type: 'string',  required: false },
  nome:   { type: 'string',  required: false },
  padrao: { type: 'boolean', required: false },
})
